<template>
<div>


<!--   <Section background="white"  class="image-bg"-->
<!--            :style="{'background-image': `url(${require('../../assets/images/content/pexels-pixabay-33153.jpg')})`}"-->

<!--   >-->

<!--      <nav-bar dark></nav-bar>-->
<!--      &lt;!&ndash;      <div class=" main-heading heading-line pt-1">&ndash;&gt;-->
<!--      &lt;!&ndash;      </div>&ndash;&gt;-->

<!--&lt;!&ndash;      <div class=" main-heading heading-line" style=" width: 100%;" >&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->

<!--      <div class=" main-heading" style=" width: 100%;" >-->
<!--         <v-container fluid class="heading-line">-->
<!--            <div class="center display-2">Radio Schedule</div>-->
<!--         </v-container>-->
<!--      </div>-->


<!--   </Section>-->






   <v-container>
      <section id="main_section">
         <article>
            <p style="margin-bottom:20px;"></p>
            <!--
            <audio controls>
               <source src="data/radio/Living the Bible/100_Rev_19_d_dnn.mp3" type="audio/mpeg">
               Your browser does not support the audio element.
            </audio>
            <a href = "data/radio/Living the Bible/100_Rev_19_d_dnn.mp3">  Christmas</a>
            --->
            <p style="font-size: 15pt">
            Mieko produces a number radio programs which are aired both within the US as well as
            internationally in  Japan, Europe, and Africa.
            If you would like to listen, please see the schedules below.
            </p>


            <p style="margin-bottom:40px;"></p>
            <h2> United States</h2>


            <table class="mytable">
               <tr class="table_firstrow">
                  <th >Station</th><th>Region</th><th>Day</th><th>Time</th><th>Frequency</th>
               </tr>
               <tr>
                  <td>KLNG</td>
                  <td>Omaha, NE</td>
                  <td>Saturday</td>
                  <td>1:00PM</td>
                  <td>1560 kHz AM </td>
               </tr>
               <tr><td>WSKY</td><td>Asheville, NC </td><td>Sunday</td><td>6:30PM</td><td>1230 kHz AM</td></tr>
               <tr><td>WFAM </td><td>Augusta, GA</td><td>Sunday</td><td>5:00AM</td><td>1050 kHz AM </td></tr>
               <tr><td>WBXR </td><td>Huntsville, AL</td><td>Sunday</td><td>5:00PM</td><td>1140 kHz AM</td></tr>
               <tr><td>WELP</td><td>Greenville, SC</td><td>Saturday</td><td>6:30PM</td><td>1360 kHz AM</td></tr>
               <tr><td>WWNL</td><td>Pittsburgh, PA</td><td>Sunday</td><td>8:30AM</td><td>1080 kHz AM</td></tr>
               <tr><td>WBRI</td><td>Indianapolis, IN</td><td>Sunday</td><td>6:30PM</td><td>1500 kHz AM</td></tr>
               <tr><td>KXKS</td><td>Albuquerque, NM</td><td>Sunday</td><td>9:00AM</td><td>1190 kHz AM</td></tr>
               <tr><td>WNVY</td><td>Pensacola, FL</td><td>Sunday</td><td>9:00AM</td><td>1070 kHz AM</td></tr>
               <tr><td>WCPC</td><td>Tupelo, MS</td><td>Saturday</td><td>8:00AM</td><td>940 kHz AM</td></tr>
            </table>


            <p style="margin-bottom:40px;"></p>
            <h2> International</h2>

            <table class="tableizer-table">
               <tr class="tableizer-firstrow">
                  <th>Station</th><th>Region</th><th>Day</th><th>Time</th><th>Frequency</th>
               </tr>
               <tr>
                  <td class="my-table-cell">T8WH</td>
                  <td class="my-table-cell">Asia</td>
                  <td class="my-table-cell" >Saturday</td>
                  <td class="my-table-cell">1200UTC</td>
                  <td class="my-table-cell">9965 Khz (shortwave)</td>
               </tr>
               <tr><td>WRMI</td><td>Central/south Amer.</td><td>Sunday</td><td>9:00am</td><td>9955 Khz (shortwave)</td></tr>
               <tr><td>Voice of Europe</td><td>Europe</td><td>Sunday</td><td>8:00pm</td><td>1368 kHz (AM)</td></tr>
               <tr><td>Source of Faith</td><td>Haiti</td><td>Tuesday</td><td>9:30am</td><td>106.3 MHz (FM)</td></tr>
               <tr><td>Joyful Skies</td><td>Israel</td><td>Sunday</td><td>9:45pm</td><td>98.7 MHz  (FM)</td></tr>
               <tr><td>Radio Viascity</td><td>Sierra Leone</td><td>Sunday</td><td>8:00am</td><td>100.6 MHz (FM)</td></tr>
               <tr><td>Radio Africa</td><td>Africa</td><td>Tuesday</td><td>1900 UTC</td><td>17790 kHz (shortwave)</td></tr>
               <tr><td>Radio Africa</td><td>Africa</td><td>Tuesday</td><td>1530 UTC</td><td>17790 kHz (shortwave)</td></tr>
               <tr><td>Radio East Africa</td><td>East Africa</td><td>Sunday</td><td>1900 UTC</td><td>17790 kHz (shortwave)</td></tr>
            </table>
         </article>
      </section>
   </v-container>


</div>
</template>

<script>

import navBar from '@/components/navBar.vue'
import Section from "@/components/Section";
import AudioPlayer from "@/components/AudioPlayer";

export default {
name: "Radio",
   components: {navBar, Section, AudioPlayer},
}
</script>

<style scoped>
.image-bg{
   background-size: cover;
   background-position: center;
   height: 300px;
}

   td{
      padding-left: 10px;
      padding-right: 10px;
   }


.main-heading{
   height: 200px;
   display: flex;
   align-items: center;
   justify-content: center;

}


.heading-line{
   text-align: center;
   color:#ffffff;
   /*background-color:rgba(43,43,43,0.4);*/
   width: 100%;

}

</style>
